document.addEventListener('DOMContentLoaded', async function () {
  const skuElement = document.getElementById('variant-sku');
  const barcodeElement = document.getElementById('variant-barcode');

  if (!skuElement || !barcodeElement) return;

  try {
    // Produktdaten direkt von Shopify laden
    const productUrl = window.location.pathname.replace(/\/$/, '') + '.js';
    const response = await fetch(productUrl);
    const product = await response.json();

    function updateVariantData() {
      let variantId = null;

      // 1. Varianten-ID aus der URL holen
      const urlParams = new URLSearchParams(window.location.search);
      variantId = urlParams.get('variant');

      // 2. Falls nicht in URL: Varianten-ID aus dem Warenkorb-Formular holen
      if (!variantId) {
        const variantInput = document.querySelector(
          'form[action*="/cart/add"] [name="id"]'
        );

        if (variantInput) {
          variantId = variantInput.value;
        }
      }

      if (!variantId) return;

      const variant = product.variants.find(
        v => String(v.id) === String(variantId)
      );

      if (!variant) return;

      skuElement.textContent = variant.sku || 'SKU nicht verfügbar';
      barcodeElement.textContent =
        variant.barcode || 'Barcode nicht verfügbar';
    }

    // Beim ersten Laden
    updateVariantData();

    // Bei jeder Variantenänderung
    document.addEventListener('change', function () {
      setTimeout(updateVariantData, 150);
    });

  } catch (error) {
    console.error('Fehler beim Aktualisieren von SKU und Barcode:', error);
  }
});